import { Box, Skeleton, Stack } from "@mui/material";

export const SkillDetailSkeleton = () => {
  return (
    <Box
      sx={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column" }}
      data-testid="skills-detail-skeleton"
    >
      <Box
        sx={{
          py: 0.875,
          px: 1.3125,
          borderBottom: 1,
          borderColor: "divider",
        }}
        data-testid="skills-detail-skeleton-header"
      >
        <Stack gap={0.75}>
          <Stack direction="row" gap={2} alignItems="flex-start">
            <Skeleton variant="text" width="34%" height={36} />
            <Stack
              direction="row"
              gap={0.5}
              alignItems="flex-start"
              justifyContent="flex-end"
              sx={{ flexShrink: 0, ml: "auto" }}
            >
              {Array.from({ length: 5 }).map((_, index) => (
                <Skeleton
                  key={index}
                  variant="circular"
                  width={32}
                  height={32}
                />
              ))}
            </Stack>
          </Stack>

          <Stack direction="row" gap={1.5} alignItems="center" flexWrap="wrap">
            <Skeleton variant="text" width={142} height={24} />
            <Skeleton variant="text" width={126} height={24} />
            <Skeleton variant="text" width={58} height={24} />
          </Stack>
          <Stack direction="row" gap={0.75} alignItems="center" flexWrap="wrap">
            <Skeleton variant="rounded" width={76} height={20} />
            <Skeleton variant="rounded" width={84} height={20} />
          </Stack>
        </Stack>
      </Box>

      <Box
        sx={{ overflow: "auto", py: 0.875, px: 1.3125 }}
        data-testid="skills-detail-skeleton-body"
      >
        <Stack gap={2.5} sx={{ maxWidth: 920 }}>
          <Box>
            <Skeleton variant="text" width={88} height={20} />
            <Skeleton variant="text" width="68%" height={28} sx={{ mt: 0.5 }} />
            <Skeleton variant="text" width="52%" height={28} />
          </Box>

          <Box>
            <Skeleton variant="text" width={96} height={20} />
            <Skeleton
              variant="rounded"
              width="100%"
              height={220}
              sx={{ mt: 0.75 }}
            />
          </Box>
        </Stack>
      </Box>
    </Box>
  );
};
